import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getDepositRequests } from '../depositRequestsEndpoints'
import { depositRequestKeys } from '../depositRequestsQueryKeys'
import type { GetDepositRequestsParams } from '../../types/depositRequestsTypes'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 10

export function useDepositRequestsListQuery(
  filters: MaybeRefOrGetter<Partial<GetDepositRequestsParams>>,
) {
  return useQuery({
    queryKey: () => depositRequestKeys.list(toValue(filters)),
    queryFn: () =>
      getDepositRequests({
        page: DEFAULT_PAGE,
        limit: DEFAULT_LIMIT,
        ...toValue(filters),
      }),
    placeholderData: keepPreviousData,
  })
}
